import { mutateAdmin, queryAdmin } from '../graphql-client';

const statusUpdateFragment = /* GraphQL */ `
  id
  timestamp
  type
  payload
`;

export const GET_STATUS_UPDATE_LIST = /* GraphQL */ `
  query getStatusUpdates($contentId: String!, $contentTypeName: String!){
    result: getStatusUpdateList(contentId: $contentId, contentTypeName: $contentTypeName) {
      items {
        ${statusUpdateFragment}
      }
    }
  }
`;

export const CREATE_STATUS_UPDATE_MUTATION = /* GraphQL */ `
  mutation ($input: TSScheduleStatusUpdateInput!) {
    scheduleStatusUpdate(input: $input) {
      ${statusUpdateFragment}
    }
  }
`;

export const CANCEL_STATUS_UPDATE_MUTATION = /* GraphQL */ `
  mutation ($input: TSCancelStatusUpdateInput!) {
    cancelStatusUpdate(input: $input)
  }
`;

export const createStatusUpdate = mutateAdmin(CREATE_STATUS_UPDATE_MUTATION);
export const cancelStatusUpdate = mutateAdmin(CANCEL_STATUS_UPDATE_MUTATION);
export const getStatusUpdateList = queryAdmin(GET_STATUS_UPDATE_LIST);
